import type { Workspace } from './model'

/** Revisions describe complete immutable snapshots within one workspace. */
export function shouldAcceptWorkspace(
  current: Pick<Workspace, 'id' | 'revision'>,
  incoming: Pick<Workspace, 'id' | 'revision'>,
  initialized: boolean,
): boolean {
  return !initialized || incoming.id !== current.id || incoming.revision > current.revision
}
